// Foundation JavaScript
// Documentation can be found at: http://foundation.zurb.com/docs


jQuery( document ).ready(function( $ ) {

	// Handle Header Margin Top
	if ($(".header--sticky").length) {
		var h = $(".header--sticky").height();
		var $next_sibling = $(".header--sticky").next();

		$next_sibling.css('margin-top', h);

		$( window ).resize(function() {
			$next_sibling.css('margin-top', $(".header--sticky").height());
		});
	}

	// Handle Search Form
	if ($(".search__trigger").length) {
		$(".search__trigger").on("click", function(e){
			e.preventDefault();
			$(".header__menu").fadeOut("fast");
			$(".header__detail").fadeOut("fast", function(){				
				$("#search__form").fadeIn();
			});
			
		});

		$(".cancel__button").on("click", function(e){
			e.preventDefault();
			$("#search__form").fadeOut("fast", function(){
				$(".header__menu").fadeIn("fast");
				$(".header__detail").fadeIn("fast");
			});
		});
	}

	// Main Search Toggle Medium Screen
	if ($(".header__search__toggle").length) {
		var searchIsOpen = false;
		// Search Toggle
		$(".header__search__toggle").on('click', function(){

			if (!searchIsOpen) {
				searchIsOpen = true;
				$("#search__form").slideDown("fast");
			}
			else {
				searchIsOpen = false;
				$("#search__form").slideUp("fast");
			}
			
		});

	}

	// Handle Bag
	if ($(".bag__trigger").length) {
		var bagIsOpen = false;

		$(".bag__trigger").on("click", function(e){
			e.preventDefault();
			if (!bagIsOpen) {
				bagIsOpen = true;
				$(".dropdown-bag").fadeIn("fast");
			}
			else {
				bagIsOpen = false;
				$(".dropdown-bag").fadeOut("fast");
			}
			
		});

		$(window).scroll(function(){
			if (bagIsOpen) {
				bagIsOpen = false;
				$(".dropdown-bag").fadeOut("fast");
			}
		});
	}


	$(".subscribe__form__submit").on('click', function(e){
		e.preventDefault();
		$(".subscribe__form__group").fadeOut("fast", function(){
			$(".subscribe__form__notify").fadeIn();
		});
		
	});

	// Main Menu Toggle
	if ($(".header__menu__toggle").length) {

		// Menu Toggle
		$(".header__menu__toggle").on('click', function(){
			$('.header__menu__nav').slideToggle();
		});

	}

	// Thumbnails
	if ($(".thumbnails").length) {
		$(".thumbnails").simpleGal({
			mainImage: '.custom'
		});
	}

	// Filter Dropdown
	if ($(".dropdown__container").length) {
		$(".dropdown__heading").on("click", function(e){
			var self = $(this);
			self.next(".dropdown__content").slideToggle("fast", function(){

				if (self.children("i.fa-caret-up").length) {
					self.children("i.fa-caret-up").removeClass("fa-caret-up").addClass("fa-caret-down");
				}
				else {
					self.children("i.fa-caret-down").removeClass("fa-caret-down").addClass("fa-caret-up");
				}

			});
		});
	}



});